import BaseAPIService from '@/services/baseAPIService'

export default class PricingAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }

  // Stock Sales Pricing
  updateStockSalesPrices(id, data)  { return this.httpClient.put(`/pricing/stock/${id}/salespricing`, data) }
  
  updateSupplierStockPrices(id, data) { return this.httpClient.put(`/pricing/supplier/${id}/pricing`, data) }

  // Price Requests
  getPriceRequest(id)                 { return this.httpClient.get(`/pricing/requests/${id}`) }
  createPriceRequest(data)            { return this.httpClient.post(`/pricing/requests`, data) }
  updatePriceRequest(id, data)        { return this.httpClient.put(`/pricing/requests/${id}`, data) }
  approvePriceRequest(id, data)       { return this.httpClient.post(`/pricing/requests/${id}/approve`, data) }
  denyPriceRequest(id, data)          { return this.httpClient.post(`/pricing/requests/${id}/deny`, data) }
  applyPriceRequest(id)               { return this.httpClient.post(`/pricing/requests/${id}/apply`) }
  cancelPriceRequest(id, data)        { return this.httpClient.post(`/pricing/requests/${id}/cancel`, data) }
  revertPriceRequest(id)              { return this.httpClient.post(`/pricing/requests/${id}/revert`) }
  revertPriceRequestToDraft(id)       { return this.httpClient.post(`/pricing/requests/${id}/reverttodraft`) }
  completePriceRequestDraftMode(id)   { return this.httpClient.post(`/pricing/requests/${id}/completedraft`) }
  getPriceRequestList(filter) {
    var params = {}
    if(filter)
      params.filter = filter
    return this.httpClient.get(`/pricing/requests?${$.param(params)}`)
  }

  getPriceRequestStockSalesPrice(priceRequestId, stockSalesPriceId) { return this.httpClient.get(`/pricing/requests/${priceRequestId}/stocksalesprices/${stockSalesPriceId}`) }
  updatePriceRequestStockSalesPrice(priceRequestId, stockSalesPriceId, data) { return this.httpClient.put(`/pricing/requests/${priceRequestId}/stocksalesprices/${stockSalesPriceId}`, data) }
  deletePriceRequestStockSalesPrice(priceRequestId, stockSalesPriceId) { return this.httpClient.delete(`/pricing/requests/${priceRequestId}/stocksalesprices/${stockSalesPriceId}`) }

  getPriceRequestApprovalContacts(id, contactLabelIDList) {
    var params = {}
    if(contactLabelIDList)
      params.contactLabelIDList = contactLabelIDList
    return this.httpClient.get(`/pricing/requests/${id}/approvalcontacts?${$.param(params)}`)
  }
  getPriceRequestApprovalTemplate(id, messageTemplateId) {
    var params = { messageTemplateId: messageTemplateId }
    return this.httpClient.get(`/pricing/requests/${id}/approvaltemplate?${$.param(params)}`)
  }

  // Stock/Supplier Pricing
  getSupplierBulkPricingList(contactId)     { return this.httpClient.get(`/pricing/supplier/${contactId}/bulkpricing`) }
  getSupplierProcessedPricingList(contactId)     { return this.httpClient.get(`/pricing/supplier/${contactId}/processedpricing`) }
  getSupplierServicePricingList(contactId)     { return this.httpClient.get(`/pricing/supplier/${contactId}/servicepricing`) }
  getSupplierGeneralPricingList(contactId)     { return this.httpClient.get(`/pricing/supplier/${contactId}/generalpricing`) }
  getSupplierAssemblyPricingList(contactId)     { return this.httpClient.get(`/pricing/supplier/${contactId}/assemblypricing`) }

  getSupplierListForProcessedStockPriceGroup(stockId, priceGroupId)   { return this.httpClient.get(`/pricing/stock/${stockId}/pricegroup/${priceGroupId}/supplier/processedpricing`) }
  updatePreferredSupplierForProcessStockPriceGroup(stockId, priceGroupId, data) { return this.httpClient.put(`/pricing/stock/${stockId}/pricegroup/${priceGroupId}/supplier/processedpricing`, data) }
  
  updatePreferredSupplierForStock(stockId, data) { return this.httpClient.put(`/pricing/stock/${stockId}/supplier`, data) }

  

  // ---- Customer ----
  getSystemDefaultPriceList(params = {}) {
    return this.httpClient.get(`/pricing/customer/default/pricelists/default?${$.param(params)}`)
  }
  getCustomerPriceLists(contactId)                                              { return this.httpClient.get(`/pricing/customer/${contactId}/pricelists`) }
  getCustomerPriceList(contactId, id, params = {}) {
    return this.httpClient.get(`/pricing/customer/${contactId}/pricelists/${id}?${$.param(params)}`)
  }
  getCustomerDefaultPriceList(contactId, params = {}) {
    return this.httpClient.get(`/pricing/customer/${contactId}/pricelists/default?${$.param(params)}`)
  }
  archiveCustomerPriceList(contactId, id)                                       { return this.httpClient.post(`/pricing/customer/${contactId}/pricelists/${id}/archive`) }
  createCustomerPriceList(contactId, data)                                      { return this.httpClient.post(`/pricing/customer/${contactId}/pricelists`, data) }
  updateCustomerPriceList(contactId, id, data)                                  { return this.httpClient.put(`/pricing/customer/${contactId}/pricelists/${id}`, data) }
  emailCustomerPriceList(contactId, id, data)                                   { return this.httpClient.post(`/pricing/customer/${contactId}/pricelists/${id}/email`, data) }

  getCustomerPriceListEmailTemplate(contactId, id, messageTemplateId) {
    var params = { messageTemplateId: messageTemplateId }
    return this.httpClient.get(`/pricing/customer/${contactId}/pricelists/${id}/emailtemplate?${$.param(params)}`)
  }

  // Stock / Customer Query
  getCustomerStockLookup(contactId, defaultSalesRateId, stockId, stockPriceGroupId, thickness) {
    var params = {
     stockId: stockId,
     stockPriceGroupId: stockPriceGroupId,
      thickness: thickness || 0
    }
    if(contactId)
      params.contactId = contactId
    else if(defaultSalesRateId)
      params.salesRateId = defaultSalesRateId
      
    return this.httpClient.get(`/pricing/customer/lookup?${$.param(params)}`)
  }




  // ---- Bulk Price Update Tool ----
  queryBulkPriceUpdate(data)          { return this.httpClient.post('/pricing/priceupdatetool/query', data) }


  // ---- Configuration ----

  // Stock Price Group
  getStockPriceGroupList()            { return this.httpClient.get(`/pricing/stockpricegroups`) }
  createStockPriceGroup(data)         { return this.httpClient.post(`/pricing/stockpricegroups`, data) }
  updateStockPriceGroup(id, data)     { return this.httpClient.put(`/pricing/stockpricegroups/${id}`, data) }
  updateStockPriceGroupBatch(listData){ return this.httpClient.put(`/pricing/stockpricegroups`, listData) }

  // Stock Sales Price Group
  getSalesRateList()                  { return this.httpClient.get(`/pricing/salesrates`) }
  createSalesRate(data)               { return this.httpClient.post(`/pricing/salesrates`, data) }
  updateSalesRate(id, data)           { return this.httpClient.put(`/pricing/salesrates/${id}`, data) }

  // Service Price Range / Group
  getServicePriceRangeList()             { return this.httpClient.get(`/pricing/servicepriceranges`) }
  createServicePriceRange(data)          { return this.httpClient.post(`/pricing/servicepriceranges`, data) }
  updateServicePriceRange(id, data)      { return this.httpClient.put(`/pricing/servicepriceranges/${id}`, data) }

  // Price List Configuration
  getGlobalPriceListConfig()          { return this.httpClient.get(`/pricing/pricelistconfig`) }
  updateGlobalPriceListConfig(data)   { return this.httpClient.put(`/pricing/pricelistconfig`, data) }
  getCustomerPriceListConfig(id)          { return this.httpClient.get(`/pricing/customer/${id}/pricelistconfig`) }
  updateCustomerPriceListConfig(id, data)   { return this.httpClient.put(`/pricing/customer/${id}/pricelistconfig`, data) }

  // Pricing - Config Settings
  getConfigSettings()               { return this.httpClient.get(`/pricing/config/settings`) }
  updateConfigSettings(data)        { return this.httpClient.put(`/pricing/config/settings`, data) }
}
